import { Helmet } from 'react-helmet-async'
import { useTranslation } from 'react-i18next'
import { PRODUCTS } from '@/lib/products'
import Reveal from '@/components/shared/Reveal'
import SectionHeader from '@/components/shared/SectionHeader'
import ProductCard from '@/components/shared/ProductCard'
import CtaBand from '@/components/shared/CtaBand'
import { AppLauncherLink } from '@/components/layout/AppLauncher'

export default function Products() {
  const { t } = useTranslation(['common', 'products'])

  return (
    <>
      <Helmet>
        <title>{`${t('productsPage.title')} | Tdrem`}</title>
        <meta name="description" content={t('productsPage.subtitle')} />
        <link rel="canonical" href="https://www.tdrem.com/products" />
      </Helmet>

      <section className="relative -mt-16 overflow-hidden pt-16">
        <div aria-hidden className="bg-grid absolute inset-0 -z-10" />
        <div className="container py-12 sm:py-16 md:py-20">
          <SectionHeader as="h1" eyebrow={t('productsPage.eyebrow')} title={t('productsPage.title')} subtitle={t('productsPage.subtitle')} />
        </div>
      </section>

      <section className="container pb-8">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {PRODUCTS.map((p, i) => (
            <Reveal key={p.id} delay={(i % 2) * 80}>
              <ProductCard product={p} className="h-full" />
            </Reveal>
          ))}

          {/* Existing customers: straight to the app */}
          <Reveal delay={80}>
            <div className="flex h-full flex-col rounded-3xl border border-dashed bg-muted/40 p-6">
              <h2 className="text-xl font-bold">{t('launcher.title')}</h2>
              <p className="mb-5 text-sm text-muted-foreground">{t('launcher.subtitle')}</p>
              <ul className="space-y-1">
                {PRODUCTS.map((p) => (
                  <li key={p.id}>
                    <AppLauncherLink product={p} className="rounded-xl bg-card p-2.5 shadow-soft transition-colors hover:bg-accent" />
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </section>

      <CtaBand />
    </>
  )
}
